<template>
    <div>
        <div class="row text-center my-4">
            <div class="col-sm-6 font-weight-bold text-left">Nosaukums</div>
            <div class="col-sm-6 font-weight-bold text-right">Darbības</div>
        </div>
        <div class="col-sm-12" style="max-height: 546px; overflow-x: hidden;">
            <JobTitlesItem v-for="jobTitle in currentCompany.jobTitles" :jobTitle="jobTitle" :key="jobTitle._id"/>
        </div>
    </div>
</template>
<script>
    import {mapGetters} from 'vuex';

    import JobTitlesItem from '@/components/job-titles/JobTitlesListItem';
    import * as companyStoreTypes from '../../vuex/modules/company/company.store-types';

    export default {
        name: 'job-titles-list',
        components: {JobTitlesItem},
        computed: {
            ...mapGetters('company', {
            /** @type {Company|*} */
            currentCompany: companyStoreTypes.GET_CURRENT_COMPANY,
            }),
            totalRows() {
                return this.currentCompany.jobTitles.length
            }
        }

    }
</script>